import { i18n } from "@tellescope/i18n";
import type { FreeformFieldOption, FreeformFilter } from "@tellescope/utils";

export type TagsBehavior = "match_all" | "match_any" | "match_none";

export interface ContactsTagsFilter {
  tags: string[];
  behavior: TagsBehavior;
}

export interface ContactsSourceFilter {
  sources: string[];
  behavior: TagsBehavior;
}

export interface ContactsFilters {
  careTeamIds?: string[];
  tags?: ContactsTagsFilter;
  dateOfBirth?: { from?: number; to?: number };
  source?: ContactsSourceFilter;
  freeform?: FreeformFilter[];
}

export const getContactFreedomFieldOptions: () => FreeformFieldOption[] = () => [
  { value: "fname", label: i18n.t("First Name", { ns: "contacts" }), valueType: "string" },
  { value: "lname", label: i18n.t("Last Name", { ns: "contacts" }), valueType: "string" },
  { value: "mname", label: i18n.t("Middle Name", { ns: "contacts" }), valueType: "string" },
  { value: "email", label: i18n.t("Email", { ns: "contacts" }), valueType: "string" },
  { value: "phone", label: i18n.t("Phone Number", { ns: "contacts" }), valueType: "string" },
  { value: "landline", label: i18n.t("Landline", { ns: "contacts" }), valueType: "string" },
  { value: "gender", label: i18n.t("Gender", { ns: "contacts" }), valueType: "string" },
  { value: "height", label: i18n.t("Height (inches)", { ns: "contacts" }), valueType: "number" },
  { value: "weight", label: i18n.t("Weight (pounds)", { ns: "contacts" }), valueType: "number" },
  { value: "addressLineOne", label: i18n.t("Address", { ns: "contacts" }), valueType: "string" },
  { value: "addressLineTwo", label: i18n.t("Address Line Two", { ns: "contacts" }), valueType: "string" },
  { value: "city", label: i18n.t("City", { ns: "contacts" }), valueType: "string" },
  { value: "state", label: i18n.t("State", { ns: "contacts" }), valueType: "string" },
  { value: "zipCode", label: i18n.t("ZIP Code", { ns: "contacts" }), valueType: "string" },
  { value: "timezone", label: i18n.t("Timezone", { ns: "contacts" }), valueType: "string" },
  { value: "externalId", label: i18n.t("External ID", { ns: "contacts" }), valueType: "string" },
];

export const contactFiltersAreEqual = (a: ContactsFilters, b: ContactsFilters): boolean => {
  return JSON.stringify(a) === JSON.stringify(b);
};

export const countContactActiveFilters = (filters: ContactsFilters): number => {
  let count = 0;
  if (filters.careTeamIds && filters.careTeamIds.length > 0) count++;
  if (filters.tags && filters.tags.tags.length > 0) count++;
  if (filters.dateOfBirth && (filters.dateOfBirth.from !== undefined || filters.dateOfBirth.to !== undefined)) count++;
  if (filters.source && filters.source.sources.length > 0) count++;
  if (filters.freeform) count += filters.freeform.length;
  return count;
};
